import axios from 'axios';

const API_URL = process.env.REACT_APP_API_ENDPOINT;

export const getPatientPresignedUrl = (identifier, content_type, media_extension) => {
    return axios
        .post(`${API_URL}/PatientController/create_presigned_post_url`, {
            identifier: identifier,
            content_type: content_type,
            file_extension: media_extension,
        })
        .then((r) => {
            return r.data[0];
        });
};



export const generate_patient_search_event = (identifier, identifier_type) => {
    return axios
        .post(`${API_URL}/PatientController/generate_patient_file_search_event`, {
            identifier: identifier,
            identifier_type: identifier_type,
        })
        .then((r) => {
            return r.data?.search_id;
        }).catch((err) => {
            if (err?.response?.status === 404) {
                throw 'Patient does not exist';
            }
            if (err?.response?.status === 429) {
                throw 'File search limit exceeded. Please contact support';
            }
        })
};
